import React, { useState } from 'react';
import { Button, Form } from 'react-bootstrap';

function Horariofiltrosopcion(props) {
    const [radioval, setRadioval] = useState('Estudiante');

    const continuar = (e) => {
        e.preventDefault();
        //console.log(radioval);
        props.setRol(radioval);		
	}

    const onchangeradio = (e) => {
        //console.log(e.target.value);
        setRadioval(e.target.value);
	}
    return (
        <Form onSubmit={continuar}> 
            <p>Desea ingresar como:</p>           
            <Form.Group className="mb-3" controlId="rol">
                <Form.Check type="radio" name="rol" label="Estudiante" value="Estudiante" onChange={onchangeradio} defaultChecked/>
                <Form.Check type="radio" name="rol" label="Coordinador" value="Coordinador" onChange={onchangeradio}/>
            </Form.Group>
            <Button variant="primary" type="submit">
                Continuar
            </Button>
        </Form>
    )
}

export default Horariofiltrosopcion;